import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=dc6f3572&scoped=true&"
import script from "./SendMail.vue?vue&type=script&lang=ts&"
export * from "./SendMail.vue?vue&type=script&lang=ts&"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=dc6f3572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6f3572",
  null
  
)

export default component.exports